/* ===========================================================================
   AMARA — comportements globaux.

   Rien n'est repris des scripts de la source : ni Swiper, ni les custom
   elements du thème d'origine, ni aucune app tierce. Tout est réécrit en
   JS natif et ne dépend que de l'API panier de Shopify.
   =========================================================================== */

(function () {
  "use strict";

  var $ = function (sel, racine) { return (racine || document).querySelector(sel); };
  var $$ = function (sel, racine) {
    return Array.prototype.slice.call((racine || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------- barre d'annonce --- */

  function initBarre() {
    var barre = $("[data-al-bar]");
    if (!barre) return;
    var slides = $$(".bar__slide", barre);
    if (slides.length < 2) return;

    var delai = parseInt(barre.getAttribute("data-interval"), 10) || 3000;
    var index = 0;

    setInterval(function () {
      slides[index].classList.remove("is-active");
      index = (index + 1) % slides.length;
      slides[index].classList.add("is-active");
    }, delai);
  }

  /* ----------------------------------------------------------- tiroirs --- */

  /* Les tiroirs sont des <details> : ils s'ouvrent sans JS. Le script
     n'ajoute que ce que le HTML ne sait pas faire — fermer au clic hors
     du panneau, à l'Échap, et bloquer le défilement de la page. */

  function fermer(details) {
    if (!details.hasAttribute("open")) return;
    details.removeAttribute("open");
    var resumer = details.querySelector("summary");
    if (resumer) resumer.setAttribute("aria-expanded", "false");
    verrou();
  }

  function ouvrir(details) {
    details.setAttribute("open", "");
    var resumer = details.querySelector("summary");
    if (resumer) resumer.setAttribute("aria-expanded", "true");
    verrou();
  }

  function verrou() {
    var ouvert = $$("[data-al-drawer][open]").length > 0;
    document.body.style.overflow = ouvert ? "hidden" : "";
  }

  function initTiroirs() {
    document.addEventListener("click", function (e) {
      var bouton = e.target.closest ? e.target.closest("[data-al-close]") : null;
      if (bouton) {
        var parent = bouton.closest("[data-al-drawer]");
        if (parent) { e.preventDefault(); fermer(parent); }
        return;
      }

      /* Le clic qui vient d'ouvrir un tiroir remonte jusqu'ici : sans cette
         sortie, le lien du panier ouvrirait puis refermerait aussitôt. */
      if (e.target.closest("[data-al-cart-link]")) return;

      $$("[data-al-drawer][open]").forEach(function (details) {
        var panneau = $(".drawer__content", details);
        var resumer = details.querySelector("summary");
        if (resumer && resumer.contains(e.target)) return;
        if (panneau && panneau.contains(e.target)) return;
        fermer(details);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      $$("[data-al-drawer][open]").forEach(fermer);
    });

    /* Le navigateur bascule `open` tout seul : on resynchronise l'état. */
    $$("[data-al-drawer]").forEach(function (details) {
      details.addEventListener("toggle", function () {
        var resumer = details.querySelector("summary");
        if (resumer) resumer.setAttribute("aria-expanded", details.hasAttribute("open") ? "true" : "false");
        verrou();
      });
    });
  }

  window.alOuvrirTiroir = ouvrir;
  window.alFermerTiroir = fermer;

  /* ------------------------------------------------------------ devise --- */

  /* Le <select> natif envoie le formulaire de localisation de Shopify :
     c'est lui qui pose le cookie de marché. On note le choix pour ne pas
     le réécraser par la détection automatique au rechargement. */

  function initDevise() {
    $$("[data-al-pays]").forEach(function (select) {
      select.addEventListener("change", function () {
        try { localStorage.setItem("al-devise-choisie", "1"); } catch (e) {}
        select.form.submit();
      });
    });
  }

  /* Bascule automatique : si la cliente navigue depuis un pays de la zone
     euro et qu'elle n'a jamais choisi elle-même, on passe le marché en
     euros. Shopify n'expose pas le pays visiteur en Liquid sans app, on le
     déduit donc du fuseau horaire puis de la langue du navigateur. */

  var FUSEAUX_EUR = {
    "Europe/Paris": "FR", "Europe/Brussels": "BE", "Europe/Madrid": "ES",
    "Europe/Rome": "IT", "Europe/Berlin": "DE", "Europe/Amsterdam": "NL",
    "Europe/Vienna": "AT", "Europe/Lisbon": "PT", "Europe/Dublin": "IE",
    "Europe/Luxembourg": "LU", "Europe/Helsinki": "FI", "Europe/Athens": "GR",
    "Europe/Bratislava": "SK", "Europe/Ljubljana": "SI", "Europe/Tallinn": "EE",
    "Europe/Riga": "LV", "Europe/Vilnius": "LT", "Europe/Malta": "MT",
    "Europe/Nicosia": "CY", "Europe/Monaco": "MC", "Europe/Andorra": "AD"
  };

  function paysDetecte() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (FUSEAUX_EUR[tz]) return FUSEAUX_EUR[tz];
    } catch (e) {}

    var langue = (navigator.language || "").toLowerCase();
    var region = langue.split("-")[1];
    if (region) {
      region = region.toUpperCase();
      for (var k in FUSEAUX_EUR) {
        if (FUSEAUX_EUR[k] === region) return region;
      }
    }
    if (langue.indexOf("fr") === 0) return "FR";
    return null;
  }

  function initBascule() {
    var forme = $(".shopify-localization-form");
    if (!forme) return;

    try { if (localStorage.getItem("al-devise-choisie")) return; } catch (e) { return; }

    var select = $("[data-al-pays]", forme);
    if (!select || select.name !== "country_code") return;

    var actuel = select.value;
    var vise = paysDetecte();
    if (!vise || vise === actuel) return;

    /* Le pays doit figurer dans les marchés publiés, sinon on ne touche à rien. */
    var dispo = Array.prototype.some.call(select.options, function (o) { return o.value === vise; });
    if (!dispo) return;

    try { localStorage.setItem("al-devise-choisie", "1"); } catch (e) {}
    select.value = vise;
    forme.submit();
  }

  /* ------------------------------------------------------------ panier --- */

  /* Compte à rebours de réservation, repris de l'ancien tiroir. L'échéance
     est posée une fois et gardée en session : le panier se redessine à
     chaque modification, le minuteur ne doit pas repartir de zéro à chaque
     fois ni se dupliquer. */
  var minuteurId = null;

  function initMinuteur() {
    var champ = $("[data-al-cart-minuteur]");
    if (minuteurId) { clearInterval(minuteurId); minuteurId = null; }
    if (!champ) return;

    var minutes = parseInt(champ.textContent, 10) || 10;
    var fin;
    try {
      fin = Number(sessionStorage.getItem("al-reserve-fin"));
      if (!fin || fin < Date.now()) {
        fin = Date.now() + minutes * 60000;
        sessionStorage.setItem("al-reserve-fin", String(fin));
      }
    } catch (e) {
      fin = Date.now() + minutes * 60000;
    }

    function tic() {
      var champCourant = $("[data-al-cart-minuteur]");
      if (!champCourant) { clearInterval(minuteurId); minuteurId = null; return; }
      var reste = Math.max(0, Math.floor((fin - Date.now()) / 1000));
      var m = Math.floor(reste / 60);
      var s = reste % 60;
      champCourant.textContent = m + ":" + (s < 10 ? "0" : "") + s;
      if (reste === 0) { clearInterval(minuteurId); minuteurId = null; }
    }

    tic();
    minuteurId = setInterval(tic, 1000);
  }

  function majCompteur(nombre) {
    var badge = $("[data-al-cart-count]");
    if (!badge) return;
    badge.textContent = nombre;
    badge.classList.toggle("hidden", nombre === 0);
  }

  function rafraichirPanier(ouvrirApres) {
    return fetch(window.alRoutes.cart + "?sections=al-cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["al-cart-drawer"];
        if (!html) return;
        var frais = new DOMParser().parseFromString(html, "text/html");
        var neuf = frais.querySelector("[data-al-cart-drawer]");
        var ancien = $("[data-al-cart-drawer]");
        if (neuf && ancien) {
          ancien.innerHTML = neuf.innerHTML;
          var n = parseInt(neuf.getAttribute("data-count"), 10) || 0;
          ancien.setAttribute("data-count", n);
          majCompteur(n);
        }
        initMinuteur();
        if (ouvrirApres) {
          var details = $("#Cart-drawer");
          if (details) ouvrir(details);
        }
      });
  }

  window.alRafraichirPanier = rafraichirPanier;

  function initPanier() {
    var lien = $("[data-al-cart-link]");
    var tiroir = $("#Cart-drawer");
    if (lien && tiroir) {
      lien.addEventListener("click", function (e) {
        e.preventDefault();
        ouvrir(tiroir);
      });
    }

    /* Quantités et suppressions dans le tiroir. */
    document.addEventListener("click", function (e) {
      var cible = e.target.closest ? e.target.closest("[data-al-cart-change]") : null;
      if (!cible) return;
      e.preventDefault();
      cible.disabled = true;
      fetch(window.alRoutes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          line: parseInt(cible.getAttribute("data-line"), 10),
          quantity: parseInt(cible.getAttribute("data-al-cart-change"), 10)
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function () { return rafraichirPanier(false); })
        .catch(function () { rafraichirPanier(false); });
    });
  }

  /* ------------------------------------------------------------- bandes --- */

  function initBandes() {
    $$("[data-al-slider]").forEach(function (bande) {
      var rail = $("[data-al-slider-rail]", bande);
      var prec = $("[data-al-slider-prec]", bande);
      var suiv = $("[data-al-slider-suiv]", bande);
      if (!rail) return;

      function pas() {
        var premiere = rail.firstElementChild;
        return premiere ? premiere.getBoundingClientRect().width + 2 : rail.clientWidth;
      }

      function maj() {
        if (prec) prec.disabled = rail.scrollLeft <= 1;
        /* 1px de marge : les largeurs fractionnaires empêchent l'égalité stricte. */
        if (suiv) suiv.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      }

      if (prec) prec.addEventListener("click", function () { rail.scrollBy({ left: -pas() }); });
      if (suiv) suiv.addEventListener("click", function () { rail.scrollBy({ left: pas() }); });
      rail.addEventListener("scroll", maj, { passive: true });
      window.addEventListener("resize", maj);
      maj();
    });
  }

  /* ------------------------------------------------------- ajout rapide --- */

  function initAjoutRapide() {
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;

      var bascule = e.target.closest("[data-al-tailles-bouton]");
      if (bascule) {
        e.preventDefault();
        var bloc = bascule.closest("[data-al-tailles]");
        var ouvert = bloc.classList.toggle("is-open");
        bascule.setAttribute("aria-expanded", ouvert ? "true" : "false");
        return;
      }

      var taille = e.target.closest("[data-al-ajout-rapide]");
      if (!taille || taille.disabled) return;
      e.preventDefault();
      taille.disabled = true;

      fetch(window.alRoutes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(taille.getAttribute("data-al-ajout-rapide")), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return rafraichirPanier(true); })
        .then(function () {
          taille.disabled = false;
          var bloc = taille.closest("[data-al-tailles]");
          if (bloc) bloc.classList.remove("is-open");
        });
    });
  }

  /* ------------------------------------------------------------- avis --- */

  /* Le rail défile au doigt tout seul ; le script ne sert qu'aux points,
     et à centrer la première carte comme le faisait l'ancienne section. */
  function initAvis() {
    var rail = $("[data-al-rev-rail]");
    if (!rail) return;

    var cartes = $$("[data-al-rev-carte]", rail);
    var points = $$("[data-al-rev-points] button");
    if (!cartes.length) return;

    function centrerPremiere() {
      var largeurCarte = cartes[0].offsetWidth;
      var largeurVue = rail.offsetWidth;
      if (!largeurVue) return requestAnimationFrame(centrerPremiere);
      /* Au-delà de 990px les cartes tiennent toutes : pas de recentrage. */
      if (largeurCarte * cartes.length <= largeurVue) return;
      var marge = Math.max(0, (largeurVue - largeurCarte) / 2);
      rail.style.scrollPaddingInline = marge + "px";
    }

    function maj() {
      if (!points.length) return;
      var centre = rail.scrollLeft + rail.clientWidth / 2;
      var proche = 0, ecart = Infinity;
      cartes.forEach(function (c, i) {
        var milieu = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(milieu - centre);
        if (d < ecart) { ecart = d; proche = i; }
      });
      points.forEach(function (p, i) { p.classList.toggle("is-active", i === proche); });
    }

    points.forEach(function (p, i) {
      p.addEventListener("click", function () {
        cartes[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
    });

    rail.addEventListener("scroll", maj, { passive: true });
    window.addEventListener("resize", centrerPremiere);
    centrerPremiere();
    maj();
  }

  /* --------------------------------------------------------- amorçage --- */

  function demarrer() {
    initAvis();
    initBarre();
    initTiroirs();
    initDevise();
    initBascule();
    initPanier();
    initMinuteur();
    initBandes();
    initAjoutRapide();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrer);
  } else {
    demarrer();
  }
})();
